exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ninput[type='file'][data-v-3b6ef38c] {\n  display: none;\n}\n", ""]);

